import { IDescriptionsResort, ResortOverviewTab } from '@/api/resort/types';
import { textOnly } from '@/util/sanitized';

// The snow report shows the resort-profile prose as a short, line-clamped
// teaser that links through to the full overview tab. It is rendered as a
// React text child, which means it has to arrive here already decoded:
// `sanitized()` returns HTML for the *browser* to decode, so stripping its
// tags with a regex and handing the result to React leaves the entities
// intact and the page prints them verbatim (`f&uuml;r` instead of `für`).
// `textOnly` is the helper that both strips tags and decodes entities, so
// locales whose CMS copy is entity-heavy (de, fr, it…) read correctly.
export const getOverviewTeaser = (
  resortDescriptionTabs: Array<IDescriptionsResort>,
): string => {
  const profile = (resortDescriptionTabs ?? [])
    .find((d) => d.tab === ResortOverviewTab.overview)?.description ?? '';
  return textOnly(profile).trim();
};
